/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { CrownShape } from './CrownShape';
import { Shape } from './CrownShapeCap';
import { Solids } from '@sick-davinci/glow';
import { Line, DoubleSide } from 'three';
let ShapePolyline = class ShapePolyline extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        const geometry = Solids.createPolylineUnsafe(shape.points, shape.isClosed);
        if (decoration != null && decoration.LineWidth > 0) {
            this.add(new Line(geometry, CrownShape.getLineMaterial(decoration)));
        }
        if (shape.isClosed) {
            this.geometry = Solids.createPolygonUnsafe(shape.points);
            this.material = CrownShape.getFillMaterial(material, decoration, { side: DoubleSide, depthWrite: false });
        }
    }
    format() {
        return undefined;
    }
};
ShapePolyline = tslib_1.__decorate([
    Shape('Shape.PolyLine'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], ShapePolyline);
export { ShapePolyline };
//# sourceMappingURL=ShapePolyline.js.map